import React, { useState } from 'react';
import { MainGenerator } from './MainGenerator';
import { VariantGenerator } from './VariantGenerator';
import { UpscalerPage } from './UpscalerPage';
import { DatabaseUpload } from './DatabaseUpload';
import { DirectS3DbUpload } from './DirectS3DbUpload';
import './Studio.css';

type Tab = 'generator' | 'variants' | 'upscaler' | 'database' | 'direct-s3';

export const StudioLayout: React.FC = () => {
  const [activeTab, setActiveTab] = useState<Tab>(() => {
    if (typeof window !== 'undefined' && window.location.pathname.includes('slayd-originals/upload')) {
      return 'direct-s3';
    }
    return 'direct-s3';
  });

  return (
    <div id="studio-root" style={{ height: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: 'var(--bg)', color: 'var(--text)', width: '100%' }}>
      <header>
        <div className="logo">Image Studio <span>SlaydWeb</span></div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div className="model-badge">OpenAI · Replicate</div>
        </div>
      </header>

      <nav className="top-nav">
        <button 
          className={`top-nav-btn ${activeTab === 'generator' ? 'active' : ''}`}
          onClick={() => setActiveTab('generator')}
        >
          Image Generator
        </button>
        <button 
          className={`top-nav-btn ${activeTab === 'variants' ? 'active' : ''}`}
          onClick={() => setActiveTab('variants')}
        >
          Variant Generator
        </button>
        <button 
          className={`top-nav-btn ${activeTab === 'upscaler' ? 'active' : ''}`}
          onClick={() => setActiveTab('upscaler')}
        >
          Image Upscaler
        </button>
        <button 
          className={`top-nav-btn ${activeTab === 'database' ? 'active' : ''}`}
          onClick={() => setActiveTab('database')}
        >
          DB Upload
        </button>
        <button 
          className={`top-nav-btn ${activeTab === 'direct-s3' ? 'active' : ''}`}
          onClick={() => setActiveTab('direct-s3')}
        >
          Direct S3 DB Upload
        </button>
      </nav>

      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', width: '100%' }}>
        {activeTab === 'generator' && <MainGenerator />}
        {activeTab === 'variants' && <VariantGenerator />}
        {activeTab === 'upscaler' && <UpscalerPage />}
        {activeTab === 'database' && <DatabaseUpload />}
        {activeTab === 'direct-s3' && <DirectS3DbUpload />}
      </div>
    </div>
  );
};
